<template> 
  <figure class="listitem">
    <img :src="item.pic" />
    <div class="title" >
      <div>
        <h2>{{ item.productName }}</h2>
        <!-- <h4>详情</h4> -->
      </div>
    </div>
    <!-- <figcaption>
      <p>
        {{ image.english }}
      </p>
    </figcaption> -->
  </figure>
</template>

<script>
export default {
    props: {
      item: {
            default() {
                return {
                  pic: '',
                  productName: '标题',
                }
            },
            type: Object 
        }
    },
    created() {
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
.listitem {
  font-family: "Raleway", Arial, sans-serif;
  position: relative;
  overflow: hidden;
  margin: 0;
  height: 300px;
  color: #ffffff;
  text-align: center;
  font-size: 16px;
  @media screen and (min-width: 300px) and (max-width: 768px) {
    height: 200px;
  }
}
.listitem *,
.listitem *:before,
.listitem *:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all 0.55s ease;
  transition: all 0.55s ease;
}
.listitem {
  img {
    width: 100%;
    height: 100%;

    backface-visibility: hidden;
    vertical-align: top;
    opacity: 0.9;
  }
}
.listitem .title {
  position: absolute;
  top: 58%;
  left: 25px;
  padding: 5px 10px 10px;
  cursor: pointer;
  @media screen and (min-width: 300px) and (max-width: 768px) {
    top: 15%;
    left: 20px;
  }
  h2 {
    font-size: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    display: none;
  }
}
.listitem .title:before,
.listitem .title:after {
  height: 2px;
  width: 400px;
  position: absolute;
  content: "";
  background-color: #ffffff;
}
.listitem .title:before {
  top: 0;
  left: 10px;
  -webkit-transform: translateX(100%);
  transform: translateX(100%);
}
.listitem .title:after {
  bottom: 0;
  right: 10px;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%);
}
.listitem .title div:before,
.listitem .title div:after {
  width: 2px;
  height: 300px;
  position: absolute;
  content: "";
  background-color: #ffffff;
}
.listitem .title div:before {
  top: 10px;
  right: 0;
  -webkit-transform: translateY(100%);
  transform: translateY(100%);
}
.listitem .title div:after {
  bottom: 10px;
  left: 0;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
}
.listitem h2,
.listitem h4 {
  margin: 0;
  text-transform: uppercase;
}
.listitem h2 {
  font-weight: 400;
}
.listitem h4 {
  display: block;
  font-weight: 700;
  background-color: #ffffff;
  padding: 5px 10px;
  color: #000000;
}
.listitem figcaption {
  position: absolute;
  bottom: 42%;
  left: 25px;
  text-align: left;
  opacity: 0;
  padding: 5px 60px 5px 10px;
  font-size: 0.8em;
  font-weight: 500;
  letter-spacing: 1.5px;
}
.listitem figcaption p {
  margin: 0;
}
.listitem a {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.listitem:hover img,
.listitem.hover img {
  zoom: 1;
  filter: alpha(opacity=35);
  -webkit-opacity: 0.35;
  opacity: 0.35;
}
.listitem:hover .title:before,
.listitem.hover .title:before,
.listitem:hover .title:after,
.listitem.hover .title:after,
.listitem:hover .title div:before,
.listitem.hover .title div:before,
.listitem:hover .title div:after,
.listitem.hover .title div:after {
  -webkit-transform: translate(0, 0);
  transform: translate(0, 0);
}
.listitem:hover .title:before,
.listitem.hover .title:before,
.listitem:hover .title:after,
.listitem.hover .title:after {
  -webkit-transition-delay: 0.15s;
  transition-delay: 0.15s;
}
.listitem:hover .title h2{
  display: block !important;
}
.listitem:hover figcaption,
.listitem.hover figcaption {
  opacity: 1;
  -webkit-transition-delay: 0.2s;
  transition-delay: 0.2s;
}
</style>



// WEBPACK FOOTER //
// src/view/components/listItemProduct.vue